import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Chip,
  Tooltip
} from "@material-ui/core";
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "src/config";

import { usersAdminStore } from "..";
import { observer } from "mobx-react";
import { companiesAdminStore } from "src/modules/admin/modules/CompaniesAdmin";
import { checkAuthStore, authStore } from "src/modules/auth/store";
import { Loading } from "src/components/loading";
import { history } from "src/history.js";
import { withRouter } from "react-router";
import { AdminToolBar } from "src/modules/admin/components";
import { validationsStore } from '../../../../validations';
import { permissionsStore } from '../../Permissions';

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  // submitButton: {
  //   backgroundColor: "#2A2A55",
  //   border: "1px solid #2D4D73",
  //   color: "#FAFAFA",
  // },
});

@observer
class UserForm extends React.Component<any> {

  public state = { current_tab: 0, siteSelectOpen: false, companySelectOpen: false }

  public toggleAppAccess = (app: any) => {
    if (app.app_id === 1) {
      if(this.props.currentUser.portal_role_id != 7 && this.props.currentUser.portal_role_id != 8) { //D-011 new
        validationsStore.validator[
          "materialSelectSiteIDs"
        ].validateFunctions[0].active = !app.Active;
        validationsStore.runValidator(
          "materialSelectSiteIDs",
          this.props.currentUser.materialSelectSiteIDs
        );
      }
      validationsStore.validator[
        "pharmacyRole"
      ].validateFunctions[0].active = !app.Active;
      validationsStore.runValidator(
        "pharmacyRole",
        this.props.currentUser.Apps.find((a: any) => a.app_id === 1).roles
      );
    } else if (app.app_id === 2) {
      validationsStore.validator[
        "universityRole"
      ].validateFunctions[0].active = !app.Active;
      validationsStore.runValidator(
        "universityRole",
        this.props.currentUser.Apps.find((a: any) => a.app_id === 2).roles
      );
    }
    return usersAdminStore.toggleUserAppAccess(app);
  };

  public getAppAccessBoxes = () => {
    return (
      this.props.currentUser.Apps.map((app: any) => {
        return (
          <div key={app.app_id}>
            <FormControlLabel
              key={app.app_id}
              control={
                <Checkbox
                  checked={app.Active}
                  disabled={this.props.match.params.view_type === 'detail'}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={() => this.toggleAppAccess(app)}
                />
              }
              label={`Access to ${app.App}?`}
            />
          </div>
        )
      })
    )
  }

  public getCompanyChipInfo = (company_id: number) => {
    const company = companiesAdminStore.all_companies.find((c: any) => c.company_id === company_id);
    if (!company) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{company.CompanyName}</b>
      </React.Fragment>
    )
  }
  
  public getSiteChipInfo = (site_id: number) => {
    const site = companiesAdminStore.all_sites.filter((s: any) => s.site_id === site_id)[0];
    if (!site) {
      return 'none'
    }
    return (
      <React.Fragment>
        <b>{site.displayName}</b> <span> ({site.CompanyName})</span>
      </React.Fragment>
    )
  }

  public render() {
    const { classes, mode } = this.props;
    // console.log(toJS(validationsStore.validator))
    //D-011
    let allCompanyData:any;
    if((authStore.currentUser.portal_role_id == 7 || authStore.currentUser.portal_role_id == 8 || this.props.currentUser.portal_role_id == 7 || this.props.currentUser.portal_role_id == 8)){
      allCompanyData = companiesAdminStore.all_companies.filter((item) => item.CompanyBusinessType != null) //D-011 new
    } else {
      allCompanyData = companiesAdminStore.all_companies; //D-011 new
    }

     /**
     * D-011 2.0 For Company Admin, Pharmacy User, User -> can't able to see distributor users in portal roles dropdown
     */
        let allPortalRolesPermissionsStore = permissionsStore.allPortalRoles;
        if (authStore.currentUser.portal_role_id == 4 || authStore.currentUser.portal_role_id == 5 || authStore.currentUser.portal_role_id == 6) {
          allPortalRolesPermissionsStore = allPortalRolesPermissionsStore.filter(item => (
            (item.portal_role_id !== 7 && item.portal_role_id !== 8)
          ))
        }
        
    if (
      !usersAdminStore.loaded ||
      !this.props.currentUser
    ) {
      return <Loading />;
    } else {

      return (
        <div>
          <Grid container={true} direction="column">
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="First Name"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.FirstName}
                  InputLabelProps={{ shrink: true }}
                  error={!validationsStore.validator["FirstName"].valid}
                  helperText={
                    !validationsStore.validator["FirstName"].valid
                      ? validationsStore.validator["FirstName"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("FirstName")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="Last Name"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.LastName}
                  InputLabelProps={{ shrink: true }}
                  error={!validationsStore.validator["LastName"].valid}
                  helperText={
                    !validationsStore.validator["LastName"].valid
                      ? validationsStore.validator["LastName"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("LastName")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="Email"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Email}
                  InputLabelProps={{ shrink: true }}
                  error={!validationsStore.validator["Email"].valid}
                  helperText={
                    !validationsStore.validator["Email"].valid
                      ? validationsStore.validator["Email"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("Email")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="Phone Number"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Phone}
                  InputLabelProps={{ shrink: true }}
                  error={!validationsStore.validator["Phone"].valid}
                  helperText={
                    !validationsStore.validator["Phone"].valid
                      ? validationsStore.validator["Phone"].errorMessage.join()
                      : " "
                  }
                  required={true}
                  onChange={this.handleInput("Phone")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="Address"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Address}
                  onChange={this.handleInput("Address")}
                  InputLabelProps={{ shrink: true }}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="City"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.City}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("City")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <TextField
                  label="State"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.State}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("State")}
                  disabled={this.props.match.params.view_type === 'detail'}
                />
              </Grid>
              <Grid item={true} xs={6}>
                <TextField
                  label="Zip"
                  classes={{ root: classes.textField }}
                  value={this.props.currentUser.Zip}
                  InputLabelProps={{ shrink: true }}
                  onChange={this.handleInput("Zip")}
                  disabled={this.props.match.params.view_type === 'detail'}
                // onBlur={this.formatPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              direction="row"
              classes={{ container: classes.rowContainer }}
              spacing={24}
            >
              <Grid item={true} xs={6}>
                <FormControl error={!validationsStore.validator['materialSelectCompanyIDs'].valid}>
                  <InputLabel htmlFor={"user_company"} shrink={true}>
                    Company
                  </InputLabel>
                  <Select
                    open={this.state.companySelectOpen}
                    // tslint:disable-next-line: jsx-no-lambda
                    onOpen={() => this.setState({ companySelectOpen: true })}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClose={() => this.setState({ companySelectOpen: false })}
                    multiple={true}
                    inputProps={{
                      name: "user_company",
                      id: "user_company",
                    }}
                    value={this.props.currentUser.materialSelectCompanyIDs}
                    classes={{ root: classes.companySelect }}
                    onChange={this.handleInput("materialSelectCompanyIDs")}
                    disabled={this.props.match.params.view_type === 'detail'}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderValue={(selected: any) => {
                      if (this.props.match.params.view_type === 'detail') {
                        return (
                          <div style={{ whiteSpace: 'normal' }}>
                            {selected.map((c: any) => (
                              <Chip style={{ marginTop: '3px' }} key={c} label={this.getCompanyChipInfo(c)} className={classes.chip} />
                            ))}
                          </div>
                        )
                      }
                      return (
                        <div style={{ whiteSpace: 'normal' }}>
                          {selected.map((c: any) => (
                            <Chip style={{ marginTop: '3px' }} key={c} label={this.getCompanyChipInfo(c)} className={classes.chip} onDelete={() => { if (document.activeElement) { (document.activeElement as HTMLElement).blur() }; this.dropCompany(c) }} />
                          ))}
                        </div>
                      )
                    }}
                  >
                    {this.props.currentUser['portal_role_id'] ? (allCompanyData
                      .filter(companie => companie.PortalDeletedAt === null) // B-014 D-011
                      .map(
                        (company: any, index) => {
                          return (
                            <MenuItem key={index} value={company.company_id}>
                              {company.CompanyName}
                            </MenuItem>
                          );
                        }
                      )): ''}
                  </Select>
                  <FormHelperText>
                    {!validationsStore.validator["materialSelectCompanyIDs"].valid
                      ? validationsStore.validator["materialSelectCompanyIDs"].errorMessage.join()
                      : " "}
                  </FormHelperText>
                </FormControl>
                {this.getAppAccessBoxes()}
                {
                  this.props.match.params.view_type === 'edit' ?
                    <Button
                      variant={'contained'}
                      classes={{ root: classes.submitButton }}
                      // tslint:disable-next-line: jsx-no-lambda
                      onClick={() => this.props.history.push('/admin/users/edit/password/' + this.props.currentUser.auth_id)}
                    >
                      Change User Password
                    </Button>
                    :
                    null
                }

              </Grid>

              <Grid item={true} xs={6}>
                <FormControl error={!validationsStore.validator['materialSelectSiteIDs'].valid}>
                  <InputLabel htmlFor={"user_site"} shrink={true}>
                    Pharmacy
                  </InputLabel>
                  <Select
                    open={this.state.siteSelectOpen}
                    // tslint:disable-next-line: jsx-no-lambda
                    onOpen={() => this.setState({ siteSelectOpen: true })}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClose={() => this.setState({ siteSelectOpen: false })}
                    multiple={true}
                    inputProps={{
                      name: "user_site",
                      id: "user_site",
                    }}
                    value={this.props.currentUser.materialSelectSiteIDs}
                    classes={{ root: classes.companySelect }}
                    onChange={this.handleInput("materialSelectSiteIDs")}
                    disabled={this.props.match.params.view_type === 'detail'}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderValue={(selected: any) => {
                      if (this.props.match.params.view_type === 'detail') {
                        return (
                          <div style={{ whiteSpace: 'normal' }}>
                            {selected.map((c: any) => (
                              <Chip style={{ marginTop: '3px' }} key={c} label={this.getSiteChipInfo(c)} className={classes.chip} />
                            ))}
                          </div>
                        )
                      }
                      return (
                        <div style={{ whiteSpace: 'normal' }}>
                          {selected.map((c: any) => (
                            <Chip style={{ marginTop: '3px' }} key={c} label={this.getSiteChipInfo(c)} className={classes.chip} onDelete={() => { if (document.activeElement) { (document.activeElement as HTMLElement).blur() }; this.dropSite(c) }} />
                          ))}
                        </div>
                      )
                    }}

                  >
                    {companiesAdminStore.all_sites
                      .filter((site: any) => this.props.currentUser.materialSelectCompanyIDs.includes(site.company_id))
                      .map(
                        (site: any, index) => {
                          return (
                            <MenuItem key={index} value={site.site_id}>
                              {/* {site.displayName + ' (' + site.CompanyName + ')'} */}
                              {<React.Fragment><span style={{ fontWeight: 'bold' }}>{site.displayName}</span> <span style={{ fontSize: '12px' }}> ({site.CompanyName})</span></React.Fragment>}
                            </MenuItem>
                          );
                        }
                      )}
                  </Select>
                  <FormHelperText>
                    {!validationsStore.validator["materialSelectSiteIDs"].valid
                      ? validationsStore.validator["materialSelectSiteIDs"].errorMessage.join()
                      : " "}
                  </FormHelperText>
                </FormControl>

                <br />

                <FormControl error={!validationsStore.validator['portal_role_id'].valid}>
                  <InputLabel htmlFor={"portal_role"} shrink={true}>
                    Portal Role
                </InputLabel>
                  <Select
                    inputProps={{ name: "portal_role", id: "portal_role" }}
                    value={this.props.currentUser.portal_role_id || 0}
                    classes={{ root: classes.roleSelect }}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={this.handleInput('portal_role_id')}
                    disabled={this.props.match.params.view_type === 'detail'}
                  >
                    {allPortalRolesPermissionsStore.filter((role: any) => role.portal_role_id >= authStore.currentUser.portal_role_id).map((role: any, index: number) => { //D-011
                      return (
                        <MenuItem key={index} value={role.portal_role_id}>
                          {role.PortalRoleName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>
                    {!validationsStore.validator["portal_role_id"].valid
                      ? validationsStore.validator["portal_role_id"].errorMessage.join()
                      : " "}
                  </FormHelperText>
                </FormControl>
                <br />
                <br/>

                <FormControl //D-011 all FormControl
                  error={!validationsStore.validator["materialSelectDistributorIDs"].valid}
                >
                  <InputLabel htmlFor={"user_distributor"} shrink={true}>
                    Distributor Name
                  </InputLabel>
                  <Select
                    inputProps={{ name: "distributor", id: "id" }}
                    value={this.props.currentUser.materialSelectDistributorIDs || 0}
                    classes={{ root: classes.roleSelect }}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={this.handleInput("materialSelectDistributorIDs")}
                    disabled={this.props.match.params.view_type === "detail"}
                  >
                    {(this.props.currentUser['portal_role_id'] == 7 || this.props.currentUser['portal_role_id'] == 8) ? companiesAdminStore?.all_distributor?.map(
                      (distributor: any, index: number) => {
                        return (
                          <MenuItem key={index} value={distributor.id}>
                            {distributor.distributor}
                          </MenuItem>
                        );
                      }
                    ) : ''}
                  </Select>
                  <FormHelperText>
                    {!validationsStore.validator["materialSelectDistributorIDs"].valid
                      ? validationsStore.validator[
                          "materialSelectDistributorIDs"
                        ].errorMessage.join()
                      : " "}
                  </FormHelperText>
                </FormControl>

              </Grid>
              {/* </Grid> */}
            </Grid>
            <Grid item={true} xs={6} />
          </Grid>
        </div>
      );
    }
  }

  @action
  public dropSite = (site_id: number) => {
    this.props.currentUser.materialSelectSiteIDs = this.props.currentUser.materialSelectSiteIDs.filter((s: any) => s !== site_id);
    validationsStore.runValidator('materialSelectSiteIDs', this.props.currentUser.materialSelectSiteIDs)
  };

  @action
  public dropCompany = (company_id: number) => {
    this.props.currentUser.materialSelectCompanyIDs = this.props.currentUser.materialSelectCompanyIDs.filter((c: any) => c !== company_id);
    validationsStore.runValidator('materialSelectCompanyIDs', this.props.currentUser.materialSelectCompanyIDs)
  };

  @action
  protected handleInput = (property: string) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    this.setState({ siteSelectOpen: false, companySelectOpen: false })
    this.props.currentUser[property] = e.target.value;
    validationsStore.runValidator(property, this.props.currentUser[property] = e.target.value)
  };

}

export default withStyles(styles, { withTheme: true })(
  withRouter(UserForm)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UsersForm.tsx